<!-- src/app/demo/components/documents/documents-list.component.html -->
<div class="layout-dashboard"></div>
<div class="grid">
    <div class="col-12 xl:col-12">
        <div class="card">
            <div class="flex w-full justify-content-between align-items-center">
                <h4>{{'CUSTOMERS_WITH_PENDING_DOCUMENTS' | translate}}</h4>
            </div>
            <div class="spacer"></div>
            <p-table
                [paginator]="true"
                [rows]="20"
                (onPage)="paginate($event)"
                responsiveLayout="scroll"
                [value]="customers()"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'CUSTOMER_NAME' | translate}}</th>
                        <th>{{'CUSTOMER_TYPE' | translate}}</th>
                        <th>{{'CONTACT_PERSON_FIRST_NAME' | translate}}</th>
                        <th>{{'CONTACT_PERSON_LAST_NAME' | translate}}</th>
                        <th>{{'CONTACT_MOBILE_NUMBER' | translate}}</th>
                        <th>{{'CONTACT_EMAIL' | translate}}</th>
                        <th>{{'ACTIONS' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-customer>
                    <tr>
                        <td>{{ customer.customerName }}</td>
                        <td>{{ translate.instant(customer.customerType) }}</td>
                        <td>{{ customer.contactInfo.firstName }}</td>
                        <td>{{ customer.contactInfo.surname }}</td>
                        <td>{{ customer.contactInfo.contactMobileNumber }}</td>
                        <td>{{ customer.contactInfo.contactEmail }}</td>
                        <td>
                            <p-button
                                class="table-button"
                                pTooltip="View document details"
                                icon="pi pi-info-circle"
                                (onClick)="goToCustomerView(customer.id)"
                                [rounded]="true"
                                [text]="true"
                                severity="info"
                            />
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
